/* eslint-disable */

import React from 'react';

const LoginLinks = (props) => {
  const handleSwitchForm = (name) => {
    this.props.handleSwitchForm(name);
  };

  return (
    <div className="login-links-container">
      {props.currentPage && props.currentPage === 'login' ? (
        <a
          href="#"
          onClick={() => props.handleSwitchForm('forgotPassword')}
          className="login-link"
        >
          Forgot Password
        </a>
      ) : (
        <a
          href="#"
          onClick={() => props.handleSwitchForm('login')}
          className="login-link"
        >
          Login Page
        </a>
      )}
    </div>
  );
};

export default LoginLinks;



// WEBPACK FOOTER //
// ./src/screens/Auth/LoginLinks.js